import { apiLaravelClient } from '../utils/apiLaravelClient';

export function getTwilioToken(params) {
	return apiLaravelClient.get(`/get/twilio/token/${params.identity}/${params.roomName}`);
}

export function getVideoTwilioToken(params) {
	return apiLaravelClient.get(`/api/v0.1/videoroom/token/${params.identity}/${params.roomName}`);
}

export function sendTextMessage(data, headers) {
	return apiLaravelClient.post(`/api/twilio/send/sms`, data, {headers});
}


export function logError(data) {
	return apiLaravelClient.post(`/api/v0.1/kureweb/log`, data);
}

export function sendSupervisionAction(data) {
	return apiLaravelClient.post(`/save/timeline/reminder/data`, data);
}

export function getUserAccess(userId) {
	return apiLaravelClient.get(`api/v0.2/workflow/${userId}/roles`);
}